import React from 'react';
import _merge from 'lodash/merge';
import { getContext } from 'common';
import styled from './styles';

export interface StatusBarTextTitleProps extends React.ComponentPropsWithRef<'div'> {
  /** Children prop is where content resides. */
  children: string;
  /** To override the theme please refer to the "Readme" tab to learn more. */
  theme?: any;
}

/**
 * StatusBarTextTitle component. This component is the wrapper of div with defined bold font styles.
 * Any other props than the `children` props will be provided to the root element
 */
const StatusBarTextTitle = React.forwardRef<HTMLElement, StatusBarTextTitleProps>((props: StatusBarTextTitleProps, ref) =>
  getContext(({ RTL, theme }) => {
    const { children, theme: propTheme, ...otherProps } = props;
    const resolvedTheme = _merge({}, theme.STATUSBAR, propTheme);
    return (
      <styled.StatusBarTextTitle ref={ref} $rtl={RTL} $theme={resolvedTheme} {...otherProps}>
        {children}
      </styled.StatusBarTextTitle>
    );
  }));

StatusBarTextTitle.displayName = 'StatusBarTextTitle';

StatusBarTextTitle.defaultProps = {
  theme: {}
};

export default StatusBarTextTitle;
